import { AbstractControl, FormControl } from '@angular/forms';
import {
  FormAdditionalAddress,
  FormAddress,
} from '@domgen/dgx-fe-forms/address';
import { PaysafeFormField } from './paysafe-form-field.enum';

export interface PaysafeForm {
  [PaysafeFormField.AccountName]: FormControl<string | null>;
  [PaysafeFormField.Address]: AbstractControl<FormAddress>;
  [PaysafeFormField.BillingAddress]: AbstractControl<FormAdditionalAddress>;
  [PaysafeFormField.CardNumber]: FormControl<null>;
  [PaysafeFormField.Cvv]: FormControl<null>;
  [PaysafeFormField.ExpiryDate]: FormControl<null>;
  [PaysafeFormField.MonthlyRenewal]: FormControl<boolean | null>;
  [PaysafeFormField.PaperlessPreference]: FormControl<boolean | null>;
  [PaysafeFormField.TermsAndConditions]: FormControl<boolean | null>;
}
